import React from 'react';
import { RadioProps } from '../../../types/DesignSystem/Radio';
import Typography from '../Typography/Typography';

const Radio: React.FC<RadioProps> = ({
  label,
  value,
  checked,
  onChange,
  disabled = false,
  className = '',
  name,
}) => {
  return (
    <div className={`tw-flex tw-items-center tw-gap-3 ${className}`}>
      <div
        className={`tw-w-5 tw-h-5 tw-border-2 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition-colors ${
          checked
            ? 'tw-bg-white tw-border-blue-900'
            : 'tw-bg-white tw-border-grey-500'
        } ${
          disabled
            ? 'tw-opacity-50 tw-cursor-not-allowed'
            : 'hover:tw-bg-blue-100 hover:tw-border-blue-900 tw-cursor-pointer'
        }`}
        onClick={() => !disabled && onChange(value)}
        role="radio"
        aria-checked={checked}
        aria-label={label}
      >
        {checked && (
          <div className="tw-w-2 tw-h-2 tw-bg-blue-900 tw-rounded-full" />
        )}
      </div>
      <Typography variant="body-primary" className="tw-text-grey-900">
        {label}
      </Typography>
    </div>
  );
};

export default Radio;
